import React from 'react';
import ReactDOM from 'react-dom/client';
// Fonts, bundled (no request to Google): only the weights the tokens use.
import '@fontsource/barlow/400.css';
import '@fontsource/barlow/500.css';
import '@fontsource/barlow/600.css';
import '@fontsource/barlow-semi-condensed/600.css';
import '@fontsource/barlow-semi-condensed/700.css';
// Design tokens first: every stylesheet after this one uses them.
import './styles/tokens.css';
// Base components (buttons, fields, cards, KPIs, tables, badges, tabs...).
import './styles/components.css';
import './index.css';
import App from './App';
// After App: the shared phone layout comes after every page stylesheet.
import './responsive.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />); // ← SIN StrictMode